import React from 'react';
var TabContainer = function TabContainer(_ref) {
  var children = _ref.children;
  var onKeyDown = function onKeyDown(event) {
    var tabs = Array.from(event.currentTarget.querySelectorAll('[role="tab"]'));
    var current = tabs.indexOf(event.target);
    if (current === -1) return;
    var next = {
      ArrowRight: (current + 1) % tabs.length,
      ArrowLeft: (current - 1 + tabs.length) % tabs.length,
      Home: 0,
      End: tabs.length - 1
    }[event.key];
    if (next === undefined) return;
    event.preventDefault();
    tabs[next].focus();
    tabs[next].click();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "tabs-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tab-list",
    role: "tablist",
    "aria-label": "Suchbereich",
    onKeyDown: onKeyDown
  }, children));
};
export default TabContainer;